import React, { useEffect, useState } from 'react';
import Details from './details';
import Course from './course';
import Loader from '../../layouts/loader';
import apiService from '../../../services/apiService';
import MicroModule2 from '../microModule/microModule2';

const LearningSpace = () => {
    const [userInfo, setUserInfo] = useState({});
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
        const fetchUserDetails = async () => {
            try {
                let user = JSON.parse(localStorage.getItem("user_details"));
                if (user) {
                    setUserInfo(user);
                } else {
                    const token = apiService.getAuthToken()
                    const result = await apiService.get('get-org-user-info', token);
                    localStorage.setItem('user_details', JSON.stringify(result.data))
                    if (result && result.status == "success") {
                        setUserInfo(result.data);
                    }
                }
            } catch (error) {
                setLoader(false);
                console.error("Error fetching user details:", error);
            } finally {
                setLoader(false);
            }
        };

        fetchUserDetails();
    }, []);

    let orgId = localStorage.getItem("ORGID");
    let orgInfo = JSON.parse(localStorage.getItem("orgInfo"));
    const shouldReloadDetails = !userInfo || Object.keys(userInfo).length == 0

    return (
        <>
            {loader ? <Loader /> :
                <>
                    <div className='page__main'>
                        <div className="dashboard" style={{ minHeight: '100vh' }}>
                            <div className='container-fluid px-0'>
                                <Details userInfo={userInfo} />
                                <Course userOrgInfo={userInfo} />
                                {/* {(userInfo?.orgIcType === "ic" || userInfo?.orgIcType === "both") && orgInfo?.plan_id !== 'plan_1234567892' && orgInfo?.plan_id !== 'plan_1234567896' && orgInfo?.plan_id !== 'plan_1234567890' ? (
                                    <MicroModule2 orgId={orgId} />
                                ) : null} */}
                            </div>
                        </div>
                    </div>

                </>
            }
        </>
    );
};

export default LearningSpace;